import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ProtectionGate from './security/ProtectionGate';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <ProtectionGate>
    <App />
  </ProtectionGate>
);